import React from 'react'

import {
  FilterComponentProps,
  FilterOperator,
  FilterOperatorOption,
} from 'types/filter-page'

import { TextField } from 'components/ds'

import { useKeyPress } from 'hooks/use-key-press'

import { FilterOperatorSelector } from '../../filter-operator-selector'

const TextForm = ({
  label,
  value,
  onChange,
  operator = 'contains',
  onPress,
}: FilterComponentProps) => {
  const { handleKeyDown } = useKeyPress('Enter', onPress)

  const allFilterOperators: FilterOperatorOption[] = [
    {
      value: 'contains',
      component: (
        <TextField.Root
          value={value || ''}
          onChange={e => onChange(e.target.value, operator)}
          onKeyDown={handleKeyDown}
          type="text"
          placeholder={label}
          autoFocus
        />
      ),
    },
  ]

  return (
    <FilterOperatorSelector<FilterOperator>
      operator={operator}
      onChange={onChange}
      operators={allFilterOperators}
    />
  )
}

export default TextForm
